import { Project } from './project';
import { Account } from './account';
import { Section } from './section';
import { Type } from './type';
import { Attribute } from './attribute';


export interface Asset {
  id: number;
  projectId?: number;
  project?: Project;
  createAccountId?: number;
  createAccount?: Account;
  modifierAccountId?: number;
  modifierAccount?: Account;
  sectionId?: number;
  section?: Section;
  fileId?: number;
  file?: any;
  typeId?: number;
  type?: Type;
  tags?: Attribute[];
  state?: string;
  number?: number;
  status?: any;
  statusId?: number;
  objectVersion?: any;
  objectVersionId?: number;
  order?: number;
  modifyDate?: string;
  name?: string;
  class?: string;
  description?: string;
}
